import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundjunctiontoshirdi() {



  const cardData =
  {
    keyword: 'Daund Junction to Shirdi AC Bus On Rentals',
    heading: 'Sanavi Travels: Daund Junction to Shirdi AC Bus On Rentals',
    headingDescription: 'Sanavi Travels offers reliable Daund Junction to Shirdi AC Bus On Rentals, providing safe, comfortable, and air-conditioned transportation for pilgrims, families, and groups traveling from Daund to the holy town of Shirdi. Our fleet of well-maintained AC buses ensures spacious seating, smooth rides, and a stress-free journey. With professional chauffeurs, flexible one-way and round-trip rental packages, transparent pricing, railway pickup from Daund Junction, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and convenient travel. We cover major attractions including Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur, making us a trusted choice for Daund to Shirdi AC bus rentals for group travel, family trips, and religious tours.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is the primary attraction of Shirdi, dedicated to the revered saint Sai Baba. Devotees from across India and abroad visit to seek blessings, peace, and spiritual guidance. The temple complex is well-organized, making darshan and participation in aartis seamless."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir is the heart of Shirdi, housing the final resting place of Sai Baba. Pilgrims offer prayers and experience a deep sense of devotion and calm. It is considered the spiritual center of the town."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived for many years and performed miracles. The continuously burning dhuni (sacred fire) symbolizes faith and protection, attracting devotees for prayers and blessings."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the historic place where Sai Baba used to spend alternate nights. On Thursdays and special occasions, ceremonial processions are held, preserving the traditional practices associated with Sai Baba’s life."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time in meditation and care of plants. It features the sacred Nanda Deep lamp, which has been continuously lit for decades, offering a peaceful environment for devotees."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is historically significant as the site where Sai Baba was first welcomed to Shirdi. The temple remains an important landmark, reflecting the early days of Sai Baba’s presence in the town."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park depicting scenes from Sai Baba’s life using statues and traditional settings. It helps visitors understand Sai Baba’s teachings in a visual and engaging manner."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage commemorates one of Sai Baba’s closest disciples. The site reflects the deep spiritual bond between Sai Baba and his followers and is visited for inspiration and blessings."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located nearby, Shani Shingnapur is famous for the Lord Shani temple and its open-door village tradition. Devotees often visit Shani Shingnapur along with Shirdi for a holistic spiritual experience."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers recreational activities such as water rides, wave pools, and family entertainment. It provides a refreshing break for pilgrims traveling to Shirdi."
  }
]
,



"services": [
  {
    "name": "Daund Railway Station to Shirdi Bus On Rent",
    "description": "Daund Railway Station to Shirdi Bus On Rent provides comfortable and reliable bus transportation for passengers traveling from Daund to Shirdi. Fully air-conditioned buses with spacious seating and ample luggage space ensure a relaxed journey. Experienced chauffeurs manage highway driving, traffic, and route planning efficiently, making it perfect for families, groups, and tourists seeking a stress-free religious trip or leisure travel experience."
  },
  {
    "name": "Daund Shirdi Bus Hire",
    "description": "Daund Shirdi Bus Hire offers professional bus rental services for individuals, families, and groups traveling from Daund to Shirdi. Clean and well-maintained buses with skilled drivers ensure safe, comfortable, and timely travel. Suitable for pilgrimage tours, sightseeing, and long-distance journeys, this service emphasizes punctuality, convenience, and passenger satisfaction."
  },
  {
    "name": "AC Bus Daund to Shirdi",
    "description": "AC Bus Daund to Shirdi ensures a cool and comfortable ride throughout the journey. Air-conditioned buses with comfortable seating and clean interiors provide a pleasant travel experience. Experienced chauffeurs handle route management and traffic efficiently, making this service ideal for family trips, group tours, and religious pilgrims visiting Shirdi."
  },
  {
    "name": "Affordable Shirdi Bus Hire",
    "description": "Affordable Shirdi Bus Hire provides budget-friendly travel solutions for passengers traveling from Daund to Shirdi. Well-maintained, air-conditioned buses with experienced drivers offer a smooth and safe ride at economical pricing. Perfect for students, families, and small groups seeking cost-effective transport for pilgrimage trips or leisure travel."
  },
  {
    "name": "Chauffeur Driven Bus Shirdi",
    "description": "Chauffeur Driven Bus Shirdi offers a stress-free journey with professional drivers managing navigation, traffic, and scheduling. Spacious and air-conditioned buses allow passengers to relax throughout the trip. Ideal for families, corporate travelers, and tourist groups, this service emphasizes safety, punctuality, and a smooth travel experience."
  },
  {
    "name": "Best Bus Service Daund",
    "description": "Best Bus Service Daund delivers a premium and dependable travel experience from Daund to Shirdi. Well-maintained buses with trained chauffeurs ensure comfort, safety, and timely arrivals. Fully air-conditioned buses make long journeys enjoyable, while professional service guarantees a hassle-free travel experience for families, pilgrims, and tourists."
  },
  {
    "name": "Group Travel Shirdi Bus",
    "description": "Group Travel Shirdi Bus caters to large groups traveling together from Daund to Shirdi. Air-conditioned buses with ample seating and luggage space provide a comfortable environment for family, corporate, or pilgrimage groups. Experienced chauffeurs ensure timely pickups, safe driving, and efficient route planning for stress-free group travel."
  },
  {
    "name": "Family Bus Shirdi",
    "description": "Family Bus Shirdi is designed for safe and convenient family travel from Daund to Shirdi. Spacious, air-conditioned buses with comfortable seating accommodate all family members comfortably. Professional drivers prioritize smooth driving and flexible scheduling, making this service perfect for family pilgrimages or leisure trips."
  },
  {
    "name": "Tourist Bus Shirdi",
    "description": "Tourist Bus Shirdi caters to travelers visiting Shirdi and nearby attractions. Air-conditioned buses with experienced drivers provide a safe, comfortable, and organized travel experience. Ideal for families, tourist groups, and pilgrims, this service emphasizes convenience, safety, and a pleasant journey."
  },
  {
    "name": "Railway Pickup Bus Daund",
    "description": "Railway Pickup Bus Daund ensures passengers arriving at Daund railway station are transported safely and comfortably to Shirdi. Professional drivers monitor train schedules for timely pickups and provide smooth, air-conditioned bus rides. Suitable for families, solo travelers, and group pilgrims."
  },
  {
    "name": "Online Bus Booking Daund",
    "description": "Online Bus Booking Daund allows passengers to easily reserve buses from Daund to Shirdi online anytime. Users can select bus type, pickup location, travel dates, and group size with instant confirmation. Fully air-conditioned buses with professional drivers provide reliable, safe, and convenient travel planning."
  },
  {
    "name": "Sai Darshan Bus",
    "description": "Sai Darshan Bus offers specialized transportation services for pilgrims visiting the Sai Baba temple in Shirdi. Comfortable, air-conditioned buses with experienced chauffeurs ensure safe, timely, and stress-free travel. Perfect for family groups, tourists, and religious travelers seeking convenient temple transport."
  },
  {
    "name": "Outstation Bus Daund",
    "description": "Outstation Bus Daund provides reliable long-distance bus services from Daund to Shirdi and nearby destinations. Air-conditioned buses with professional drivers ensure smooth highway travel, punctual service, and flexible travel plans. Suitable for families, corporate travelers, and tourist groups seeking convenient and comfortable outstation transport."
  },
  {
    "name": "Shirdi Travel Bus",
    "description": "Shirdi Travel Bus delivers complete travel solutions for journeys from Daund to Shirdi. Spacious, air-conditioned buses with skilled chauffeurs provide safe, comfortable, and timely rides. Ideal for families, groups, and pilgrims, this service focuses on reliability, convenience, and a stress-free travel experience for religious and leisure trips."
  },
  {
    "name": "Religious Tour Bus",
    "description": "Religious Tour Bus offers dedicated transport for passengers visiting Shirdi for spiritual or religious purposes. Comfortable air-conditioned buses with trained drivers ensure safety, punctuality, and convenience. Perfect for families, groups, and devotees, this service enhances the pilgrimage experience with stress-free and reliable travel."
  }
],
"tableData": [
  ["Daund Railway Station to Shirdi Bus On Rent", "Daund Shirdi Bus Hire"],
  ["AC Bus Daund to Shirdi", "Affordable Shirdi Bus Hire"],
  ["Chauffeur Driven Bus Shirdi", "Best Bus Service Daund"],
  ["Group Travel Shirdi Bus", "Family Bus Shirdi"],
  ["Tourist Bus Shirdi", "Railway Pickup Bus Daund"],
  ["Online Bus Booking Daund", "Sai Darshan Bus"],
  ["Outstation Bus Daund", "Shirdi Travel Bus"],
  ["Religious Tour Bus", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Daund Junction to Shirdi AC Bus On Rentals with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable AC bus rentals from Daund Junction to Shirdi, ideal for group travel, pilgrimages, and family trips."
  },
  {
    "WhyChooseheading": "Air-Conditioned and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced buses to ensure a smooth and pleasant journey from Daund Junction to Shirdi."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Shirdi route, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Daund Junction to Shirdi AC bus rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with AC bus bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Bus Rental Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized AC bus packages based on your Daund Junction to Shirdi travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund Junction to Shirdi AC bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide AC bus rentals from Daund Junction to Shirdi?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable AC bus rentals for the Daund Junction to Shirdi route.'
  },
  {
    question: 'How can I book an AC bus from Daund Junction to Shirdi?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of AC buses are available?',
    answer: 'We provide air-conditioned buses suitable for group travel, pilgrimages, and family trips from Daund Junction to Shirdi.'
  },
  {
    question: 'Are drivers experienced on the Daund to Shirdi route?',
    answer: 'Yes, our professional drivers are licensed, courteous, and familiar with the Daund Junction to Shirdi journey.'
  },
  {
    question: 'Can I customize my travel itinerary?',
    answer: 'Absolutely. You can customize stops, timing, and duration according to your group’s preferences.'
  },
  {
    question: 'Is the AC bus rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock support for AC bus rentals from Daund Junction to Shirdi.'
  },
  {
    question: 'Are the buses sanitized before trips?',
    answer: 'Yes, all AC buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund Junction to Shirdi AC bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Jadhav',
    feedback: 'Rented an AC bus from Daund Junction to Shirdi. Smooth ride, clean bus, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent experience with Sanavi Travels AC bus service. Comfortable seats and punctual service.',
    rating: 5
  }
];















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund Junction to Shirdi AC Bus On Rent - Sanavi Travels",
  "description": "Sanavi Travels offers AC and chauffeur-driven buses from Daund Junction to Shirdi for Sai Darshan, family trips, group tours, and religious travel. Affordable, luxury, and reliable bus service with railway pickup and online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1100"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Daund Junction to Shirdi AC Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and chauffeur-driven buses from Daund Junction to Shirdi with Sanavi Travels. Perfect for Sai Darshan, family trips, group travel, and religious tours. Affordable, luxury, and reliable AC bus service with railway pickup and online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundjunctiontoshirdi;